/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NotifyXvOrderData = {
    type: NotifyXvOrderData.type;
};
export namespace NotifyXvOrderData {
    export enum type {
        NEW = 'new',
        CALL = 'call',
    }
}

